import getScrollbarWidth from '../../functions/get-scrollbar-width'

const list = document.querySelector('.js-navigation-list')

if (list) {
  const buttons = document.querySelectorAll('.js-navigation-button')
  const links = document.querySelectorAll('.js-navigation-link')

  const scrollbarWidth = getScrollbarWidth()

  /**
   * Show navigation
   */
  const show = function () {
    document.documentElement.style.overflowY = 'hidden'
    document.documentElement.style.paddingRight = scrollbarWidth + 'px'

    list.classList.add('is-open')
    list.setAttribute('aria-hidden', 'false')

    for (let i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-expanded', 'true')
    }
  }

  /**
   * Hide navigation
   */
  const hide = function () {
    document.documentElement.style.overflowY = ''
    document.documentElement.style.paddingRight = ''

    list.classList.remove('is-open')
    list.setAttribute('aria-hidden', 'true')

    for (let i = 0; i < buttons.length; i++) {
      buttons[i].setAttribute('aria-expanded', 'false')
    }
  }

  /**
   * Toggle between navigation states
   */
  const toggle = function () {
    if (list.classList.contains('is-open')) {
      hide()
    } else {
      show()
    }
  }

  for (let i = 0; i < buttons.length; i++) {
    buttons[i].addEventListener('click', toggle)
    buttons[i].setAttribute('aria-expanded', 'false')
  }

  for (let i = 0; i < links.length; i++) {
    links[i].addEventListener('click', hide)
  }
}



// WEBPACK FOOTER //
// ./src/components/navigation/mobile.js